import {fetchJSONByGet, fetchJSONByPost, fetchJSONByPut, fetchJSONByDel} from './index.js'
// 获取国家
export const fetchNationsApi = () => fetchJSONByGet('/admin-api/ins/dict/data/list-all?dictType=NATION')
// 获取车辆类型
export const fetchVehicleModelsApi = () => fetchJSONByGet('/admin-api/ins/dict/data/list-all?dictType=VEHICLE_MODEL')
// 获取集装箱类型
export const fetchContainerTypesApi = () => fetchJSONByGet('/admin-api/ins/dict/data/list-all?dictType=CONTAINER_TYPE')
// 获取包装类型
export const fetchPackageTypesApi = () => fetchJSONByGet('/admin-api/ins/dict/data/list-all?dictType=PACKAGE_TYPE')
// 获取运输方式
export const fetchCarriageTypesApi = () => fetchJSONByGet('/admin-api/ins/dict/data/list-all?dictType=CARRIAGE_TYPE')
// 获取公司主营业务
export const fetchCompanyBusinessApi = () => fetchJSONByGet('/admin-api/ins/dict/data/list-all?dictType=COMPANY_BUSINESS')
// 获取ERP类型
export const fetchErpTypeApi = () => fetchJSONByGet('/admin-api/ins/dict/data/list-all?dictType=ERP_TYPE')
